import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import { loadAuditLogs } from './auditLogsSlice';
import { formatRelativeTime } from '../../utils/severity';
import { tokens } from '../../theme/theme';

export default function AuditLogsPage() {
  const dispatch = useDispatch();
  const { items } = useSelector((s) => s.auditLogs);

  useEffect(() => { dispatch(loadAuditLogs()); }, [dispatch]);

  return (
    <Box>
      <PageHeader title="Audit Logs" subtitle="Append-only trail of every sensitive action across the platform — who did what, and when" />
      <Paper sx={{ overflow: 'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {['Actor', 'Action', 'Resource', 'Detail', 'When'].map((h) => (
                <TableCell key={h} sx={{ color: tokens.text.muted, fontSize: '0.68rem', textTransform: 'uppercase' }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((a) => (
              <TableRow key={a.id} hover>
                <TableCell sx={{ fontSize: '0.76rem', color: tokens.text.secondary }}>{a.actorLabel}</TableCell>
                <TableCell sx={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '0.7rem', color: tokens.brand.main }}>{a.action}</TableCell>
                <TableCell sx={{ fontSize: '0.76rem' }}>{a.resourceType} <Typography component="span" sx={{ fontSize: '0.68rem', color: tokens.text.muted }}>#{a.resourceId}</Typography></TableCell>
                <TableCell sx={{ fontSize: '0.76rem', color: tokens.text.muted, maxWidth: 300 }}>{a.detail}</TableCell>
                <TableCell sx={{ fontSize: '0.7rem', color: tokens.text.muted, whiteSpace: 'nowrap' }}>{formatRelativeTime(a.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
